import { render, staticRenderFns } from "./ai-in-trading-and-retail.vue?vue&type=template&id=b6fa9902&"
import script from "./ai-in-trading-and-retail.vue?vue&type=script&lang=js&"
export * from "./ai-in-trading-and-retail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports